/**
 * Site geneli katman uyarısı (ADR-011).
 *
 * Kütüphane listesinde rozet görünür, ama kullanıcı oynatma ekranındayken
 * (veya detay sayfasında) o listede değildir. Bu bant her ekranda görünür:
 * tünel düştüğünde "evden izleyemiyorsunuz" bilgisi gecikmeden ulaşır.
 */
import type { ReactNode } from 'react';
import type { Library } from '../api.ts';
import { unreachableSummary } from '../useLibraries.ts';

export function LayerBanner({
  libraries,
  updatedAt,
}: {
  libraries: Library[] | null;
  /** Son ölçüm zamanı — "ne zamandır erişilemiyor" ipucu için. */
  updatedAt: number | null;
}): ReactNode {
  const summary = unreachableSummary(libraries);
  if (summary === null) return null;

  return (
    <div className="banner banner--warn" role="status">
      <strong>Erişilemeyen kütüphane:</strong> {summary}
      <span className="banner__hint">
        Ev bilgisayarının açık ve WireGuard tünelinin bağlı olduğundan emin olun. Bu içerikler
        şimdilik oynatılamaz.
        {updatedAt !== null && (
          <> · Son kontrol {new Date(updatedAt).toLocaleTimeString('tr-TR')}</>
        )}
      </span>
    </div>
  );
}
